import { UserAuditLogEntry } from 'apis/auditLogs';

import { AgentBannedUser } from './agentBannedUser';
import { AgentUnbannedUser } from './agentUnbannedUser';
import { ContactMergedFrom } from './contactMergedFrom';
import { ContactMergedInto } from './contactMergedInto';
import { ConversationAssigned } from './conversationAssigned';
import { ConversationStarted } from './conversationStarted';
import { DeliveryAttemptFailed } from './deliveryAttemptFailed';
import { OrderCanceled } from './orderCanceled';
import { OrderCreated } from './orderCreated';
import { OrderDelivered } from './orderDelivered';
import { OrderDrafted } from './orderDrafted';
import { OrderFulfilled } from './orderFulfilled';
import { RefundCreated } from './refundCreated';
import { ReturnReceived } from './returnReceived';
import { ReturnRequested } from './returnRequested';
import { UserBanned } from './userBanned';
import { UserUnbanned } from './userUnbanned';

type ComponentByUserLogTypeProps = {
  entry: UserAuditLogEntry;
};

/**
 * Renders the entry component for a user (contact) audit-log entry, based on
 * its activity type.
 */
export function ComponentByUserLogType({
  entry,
}: ComponentByUserLogTypeProps): JSX.Element | null {
  switch (entry.activity_type) {
    case 'COMMERCE_ORDER_CREATED':
      return <OrderCreated entry={entry} />;
    case 'COMMERCE_ORDER_DRAFTED':
      return <OrderDrafted entry={entry} />;
    case 'COMMERCE_ORDER_CANCELED':
      return <OrderCanceled entry={entry} />;
    case 'COMMERCE_REFUND_CREATED':
      return <RefundCreated entry={entry} />;
    case 'COMMERCE_ORDER_FULFILLED':
      return <OrderFulfilled entry={entry} />;
    case 'COMMERCE_ORDER_DELIVERED':
      return <OrderDelivered entry={entry} />;
    case 'COMMERCE_DELIVERY_ATTEMPT_FAILED':
      return <DeliveryAttemptFailed entry={entry} />;
    case 'COMMERCE_RETURN_REQUESTED':
      return <ReturnRequested entry={entry} />;
    case 'COMMERCE_RETURN_RECEIVED':
      return <ReturnReceived entry={entry} />;
    case 'CONVERSATION_CREATED':
      return <ConversationStarted entry={entry} />;
    case 'CONVERSATION_ASSIGNED':
      return <ConversationAssigned entry={entry} />;
    case 'CONTACT_MERGED_INTO':
      return <ContactMergedInto entry={entry} />;
    case 'CONTACT_MERGED_FROM':
      return <ContactMergedFrom entry={entry} />;
    case 'USER_BANNED':
      return <UserBanned entry={entry} />;
    case 'USER_UNBANNED':
      return <UserUnbanned entry={entry} />;
    case 'AGENT_BANNED_USER':
      return <AgentBannedUser entry={entry} />;
    case 'AGENT_UNBANNED_USER':
      return <AgentUnbannedUser entry={entry} />;
    default:
      // Unknown/unsupported entry types render nothing (no console warning —
      // it confused support when it surfaced in bug-report recordings).
      return null;
  }
}
